import Vue from "vue";
import { formatMoney } from "@/utils/helpers";

Vue.filter("formatMoney", formatMoney);
